import React, { useEffect, useRef } from "react";

interface RoleDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  roleId: string;
}

const RoleDeleteModal: React.FC<RoleDeleteModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  roleId,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen && modalRef.current) {
      const firstButton = modalRef.current.querySelector("button");
      if (firstButton) firstButton.focus();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        ref={modalRef}
        onClick={(e) => e.stopPropagation()} 
      >
        <h2><span style={{textTransform: "capitalize"}}>A</span>re you sure you want to delete this User role?</h2>
        <div className="modal-buttons">
          <button className="modal-button2 mauve" onClick={onClose}>
            Cancel
          </button>
          <button className="modal-button2 modal-btn-red" onClick={onConfirm}>
            Yes, delete User role
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoleDeleteModal;